import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getIndustries:       (data) => apiCall("onboarding/industries",         data),
  createCompany:       (data) => apiCall("onboarding/company/create",     data),
  getCompany:          (data) => apiCall("onboarding/company/get",        data),
  updateCompany:       (data) => apiCall("onboarding/company/update",     data),
  seedAccounts:        (data) => apiCall("accounting/accounts/seed",      data),
  getSetupStatus:      (data) => apiCall("onboarding/status",             data),
  completeSetup:       (data) => apiCall("onboarding/complete",           data),
  // The badge travels as a data URL: apiCall only speaks JSON, and the server
  // re-encodes whatever arrives rather than trusting the bytes.
  uploadLogo:          (data) => apiCall("company/logo/upload",           data),
  removeLogo:          (data) => apiCall("company/logo/remove",           data || {}),
};
